import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=cc1b0182&scoped=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=cc1b0182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1b0182",
  null
  
)

export default component.exports